import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClientJsonpModule, HttpClientModule} from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FeatherModule } from 'angular-feather';
import { allIcons } from 'angular-feather/icons';
import { ToastrModule } from 'ngx-toastr';

import { Approutes } from './app-routing.module';
import { AppComponent } from './app.component';
import { SpinnerComponent } from './shared/spinner.component';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import {BreadcrumbComponent} from "./shared/breadcrumb/breadcrumb.component";
import {HorizontalNavigationComponent} from "./shared/horizontal-header/horizontal-navigation.component";
import {HorizontalSidebarComponent} from "./shared/horizontal-sidebar/horizontal-sidebar.component";
import {NgScrollbarModule} from "ngx-scrollbar";
import {ReactiveFormsModule} from "@angular/forms";
import {VerticalNavigationComponent} from "./shared/vertical-header/vertical-navigation.component";
import {VerticalSidebarComponent} from "./shared/vertical-sidebar/vertical-sidebar.component";
import {NgxSpinnerModule} from "ngx-spinner";
import { NotifierModule } from 'angular-notifier';
import {NgWizardConfig, NgWizardModule, THEME} from "ng-wizard3";
import { FlatpickrModule } from 'angularx-flatpickr';
import {BearerInterceptor} from "./core/helpers/bearer.interceptor";
import {ErrorInterceptor} from "./core/helpers/error.interceptor";
import {LoginService} from "./authentication/services/login.service";
import {provideLottieOptions} from "ngx-lottie";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const ngWizardConfig: NgWizardConfig = {
    theme: THEME.default
};

@NgModule({
    declarations: [AppComponent, SpinnerComponent ],
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        HttpClientJsonpModule,
        NgbModule,
        FeatherModule,

        FeatherModule.pick(allIcons),
        RouterModule.forRoot(Approutes),
        ToastrModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        FlatpickrModule.forRoot({locale: 'es'}),
        BreadcrumbComponent,
        HorizontalNavigationComponent,
        HorizontalSidebarComponent,
        NgScrollbarModule,
        ReactiveFormsModule,
        VerticalNavigationComponent,
        VerticalSidebarComponent,
        NgxSpinnerModule,
        NotifierModule,
        NgWizardModule.forRoot(ngWizardConfig),
        NgxExtendedPdfViewerModule
    ],
    bootstrap: [AppComponent],
    exports: [
        SpinnerComponent
    ],
    providers: [LoginService,
        { provide: HTTP_INTERCEPTORS, useClass: BearerInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        provideLottieOptions({
            player: () => import('lottie-web'),
        }),
        // { provide: LOCALE_ID, useValue: 'es' }
    ],
})
export class AppModule {}
